import App from 'app/app.js';
import 'app/directive/LtChooseSpecOrderDrawerCtrl.js';

function LtChooseSpecOrderDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onSelectPayOnly: '&',
      onSelectOrder: '&',
      onCancellation: '&',
      cancelChooseSpec: '&',
      cancellationButtonText: '@'
    },
    template:
      '    <div class="modal-body"  ng-init="chooseSpecOrderDrawer.init()" lt-drawer="chooseSpecOrderDrawer.visible" lt-drawer-cancellation="chooseSpecOrderDrawer.cancelChooseSpec()">' +
      '        <section class="row choose-spec-dialog">' +
      '           <div class="col-xs-10 col-xs-offset-1 text-center">' +
      '                   <h3 lt-translate="CHOOSE_SPEC_ORDER_TITLE"></h3>' +
      '           </div>' +
      '           <div class="col-xs-12">' +
      '               <a ng-click="chooseSpecOrderDrawer.selectPayOnly()" id="payOnlyButton" class="btn" lt-translate="CHOOSE_SPEC_ORDER_PAYONLY" data-id="button"  data-test-pay-for-pictures></a>' +
      '           </div>' +
      '           <div class="col-xs-12">' +
      '                   <a ng-click="chooseSpecOrderDrawer.selectOrder()" id="selectOrderButton" class="btn" lt-translate="CHOOSE_SPEC_ORDER_ORDER" data-id="button" data-test-order-more-pictures></a>' +
      '           </div>' +
      '           <div align="center" class="cancel-link-pad">' +
      '               <div class="col-xs-12 modal-footer-link">' +
      '                   <a ng-click="chooseSpecOrderDrawer.cancelOrder()" data-test-cancel-spec-order><span lt-translate="{{ cancellationButtonText }}" data-id="text_link" ></span></a>' +
      '               </div>' +
      '           </div>' +
      '        </section>' +
      '    </div>',
    controller: 'LtChooseSpecOrderDrawerCtrl',
    controllerAs: 'chooseSpecOrderDrawer'
  };
}

App.directive('ltChooseSpecOrderDrawer', [LtChooseSpecOrderDrawerDirective]);
